import { css } from "emotion";
import Button from "../../components/global/Button";
import Image from "../../components/Image";
import H4 from "../../components/text/H4";
import P from "../../components/text/P";
import ColorServices from "../../services/ColorServices";
import { lastOfType, max } from "../../utils/CssUtils";

const purple = ColorServices.getColor("purpleMid");

const wrapper = css({
  position: "relative",
  boxShadow: "0 1px 10px 0 rgba(9, 30, 66, 0.13)",
  borderRadius: 4,
  maxWidth: 330,
  marginRight: 12,
  verticalAlign: "top",
  "&:hover": {
    boxShadow: " 0 1px 10px 4px rgba(9, 30, 66, 0.13)"
  },
  [max(600)]: {
    maxWidth: "100%",
    width: "100%",
    height: "auto",
    img: {
      width: "100%"
    }
  },
  img: {
    borderTopRightRadius: 4,
    borderTopLeftRadius: 4
  }
});

const iconBubble = css({
  width: 70,
  height: 70,
  backgroundColor: "#fff",
  borderRadius: "50%",
  position: "absolute",
  top: -35,
  padding: 10,
  left: "calc(50% - 35px)"
});

const imageStyles = css({
  width: 50,
  height: 40,
  objectFit: "contain"
});

const textWrapper = css({
  height: "calc(100% - 165px)",
  position: "relative",
  padding: "30px 16px 0px 16px",
  textAlign: "center",
  width: "100%",
  ">h4": {
    marginBottom: 16
  },
  ">p": {
    [lastOfType()]: {
      marginBottom: 0
    },
    letterSpacing: "-0.37px",
    marginBottom: 8
  },
  [max(600)]: {
    padding: "30px 12px 1px 12px",
    ">h4": {
      marginBottom: 12
    },
    ">p": {
      marginBottom: 6
    }
  }
});

const linkStyle = css({
  marginTop: 24
});

const footer = css({
  width: "100%",
  position: "absolute",
  bottom: 29,
  left: "50%",
  transform: "translateX(-50%)",
  [max(600)]: {
    position: "static",
    transform: "none",
    margin: "24px auto"
  }
});

const impactWrapper = css({
  height: 123,
  backgroundColor: "#f9f9fa",
  padding: "20px 0",
  margin: "0 16px",
  h4: {
    marginBottom: 4
  },
  p: {
    [lastOfType()]: {
      marginBottom: 0
    },
    marginBottom: 8
  },
  [max(600)]: {
    margin: 0,
    padding: "16px 5px",
    height: 106
  }
});

const ProjectCard = ({ contentData, locale = "au" }) => {
  const {
    img,
    alt,
    title,
    textP1,
    textP2,
    ourImpactP1,
    ourImpactP2,
    link,
    icon
  } = contentData;

  const heightStyles = css({
    height: locale === "au" ? 576 : 445
  });

  const ourImpact =
    locale == "au" ? (
      <div className={impactWrapper}>
        <P marginBottom={8}>Our impact</P>
        <H4 color={purple}>{ourImpactP1}</H4>
        <P color={purple}>{ourImpactP2}</P>
      </div>
    ) : null;

  return (
    <div className={css(wrapper, heightStyles)}>
      <Image imageURL={img} alt={alt} />
      <div className={textWrapper}>
        <div className={iconBubble}>
          <img src={icon} alt={`${alt} icon`} className={imageStyles} />
        </div>

        <H4>{title}</H4>
        <P>{textP1}</P>
        <P color={purple}>{textP2}</P>

        <div className={footer}>
          {ourImpact}

          <div className={linkStyle}>
            <Button link={link} ariaLabel={`${title} information link`}>
              Learn more
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
